export enum ArtistAssetType {
    All = 'all',
    Image = 'image',
    Video = 'video',
    Collection = 'collection',
}